import NavigationService from 'services/NavigationService';
import store from '@/store/core';
import isNil from 'common/support/isNil';
import { types } from '@/store/core/mutations';
import { container } from 'tsyringe';
export default (function (app) {
    var navigationService = container.resolve(NavigationService);
    return function (to, from, next) {
        // Functionality below is not a part of NavigationService due to function requires app.router to be passed
        if (!navigationService.hasCompanyIdParam(to.fullPath) && app.currentCompanyId) {
            var newRoute = app.router.match("/c/" + app.currentCompanyId + to.path);
            if (!isNil(newRoute.name) && !newRoute.name.startsWith('Error')) {
                return next(newRoute);
            }
        }
        store.commit(types.SET_ROUTE, to);
        return next();
    };
});
